import {NOTIFICATION_TYPES, OPERATIONS, SECTIONS} from "../../../../../config/constants";
import {
    Empty,
    Select,
    Button,
    Form,
    Input,
    Space,
    Popconfirm,
    Typography, Row, Tooltip, Menu, Dropdown, Col,
} from "antd";
import { useEffect, useState } from "react";
import "./QueryForm.css";
import PageHead from "../../../../layout/PageHead";
import GroupCodesService from "../../../../../services/groupcodes/GroupCodesService";
import TablesService from "../../../../../services/tables/TablesService";
import { useTranslation } from "react-i18next";
import {
    DiffOutlined,
    CloseOutlined,
    QuestionCircleOutlined,
    DeleteOutlined, SyncOutlined, MoreOutlined

} from "@ant-design/icons";
import ExtractionService from "../../../../../services/extraction/ExtractionService";
import { ColumnsType } from "antd/lib/table";
import Datatable from "../../../../shared/components/Datatable";
import ApplicationService from "../../../../../services/application/ApplicationService";
import NotificationsUtil from "../../../../shared/utils/NotificationsUtil";
import {ROUTES} from "../../../../../config/consts/routes";
import {useParams} from "react-router-dom";
import {GetTablesRequest} from "../../../../../models/tables/GetTablesRequest";
import { GetFieldsRequest } from "../../../../../models/fields/GetFieldsRequest";
import { useNavigate } from "react-router-dom";

const routes = [
  {
    path: ROUTES.general.main.route,
    breadcrumbName: SECTIONS.general.name,
  },
  {
    breadcrumbName: SECTIONS.report.name,
  },
  {
    path: ROUTES.report.customQuery.route,
    breadcrumbName: ROUTES.report.customQuery.name,
  },
];

const initQuery = () => {
  return {
    categoryId: null,
    description: "",
    entityId: null,
    fieldId: null,
    groupCodeId: null,
    id: -1,
    isActive: true,
    isNeverCached: null,
    isSystemQuery: null,
    label: "",
    query: "",
    typeId: null
  }
}


const QueryForm = () => {
  const { t, i18n } = useTranslation("translations");

  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [operations, setOperations] = useState<any>([]);
  const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [selectedOperation, setSelectedOperation] = useState<any>();
  const [query, setQuery] = useState<any>(initQuery());
 
  const [tables, setTables] = useState<any>([]);
  const [destinationTable, setDestinationTable] = useState(null);
  const [fields, setFields] = useState<any>([]);

  const [queryCategories, setQueryCategories] = useState<any>([]);
  const [queryTypes, setQueryTypes] = useState<any>([]);
  const [isTableLoading, setIsTableLoading] = useState<boolean>(false);
  const [tableViewData, setTableViewData] = useState<any>([]);
  const [tableColumns, setTableColumns] = useState<ColumnsType<any>>([]);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const [popConfirmOpen, setPopConfirmOpen] = useState<boolean>(false);
  
  const { id } = useParams();

  const [queries, setQueries] = useState<any>([]);
  
  const [downloadLoading, setDownloadLoading] = useState<boolean>(false);

  const navigate = useNavigate();

  const resetForm = () => {
    setTableViewData(undefined);
  }
  
  useEffect(() => {
    GroupCodesService.getAll().then((response: any) => {
      const data = response.data;
      setGroupCodes(data);
    });
    
    TablesService.getAllEntities().then((response: any) => {
      const data = response.data;
      setEntities(data);
    });
    
    TablesService.getAllOperations().then((response: any) => {
      const data = response.data;
      setOperations(data);
    });

    ApplicationService.getCustomQueryCategories().then((response: any) => {
      setQueryCategories(response.data);
    });

    ApplicationService.getCustomQueryTypes().then((response: any) => {
      setQueryTypes(response.data);
    });
    
    ApplicationService.getCustomQueries().then((response: any) => {
      setQueries(response.data);
    });
    
    ExtractionService.getTables().then((response: any) => {
      setTables(response.data);
    })
    
  }, []);
  
  useEffect(() => {
    if (queries) {
      
      const storedQuery = queries.find(query => query.id === parseInt(id));
      if (storedQuery) {
        setQuery(storedQuery);
      }
    }
  }, [queries]);

  useEffect(() => {
    if (query.entityId) {
        const model: GetTablesRequest = {
            entityId: query.entityId,
            groupCode: "",
            operationId: OPERATIONS.VALIDATION,
        };

        TablesService.getTables(model).then((response: any) => {
            if (response.data && response.data.length > 0) {
                const responseData = response.data[0];
                setDestinationTable(responseData.id);
            }
        });
    }
  }, [query]);

    useEffect(() => {
        if (destinationTable) {
            const model: GetFieldsRequest = {
                tableId: destinationTable,
            };

            TablesService.getFields(model).then((response: any) => {
                if (response.data && response.data.length > 0) {
                    const responseData = response.data;
                    setFields(responseData);
                }
            });
        }
    }, [destinationTable]);

    useEffect(() => {
        if (tableViewData && tableViewData.length > 0) {
            const columnKeys = Object.keys(tableViewData[0]);
            setTableColumns(
                columnKeys.map((item: any) => ({
                    title: item,
                    dataIndex: item,
                    key: item,
                    width: 200,
                    filters: [],
                    fitlerMode: "tree",
                    filterSearch: true,
                    ellipsis: true,
                }))
            );
        }
    }, [tableViewData]);

  const onSelectedQueryTypeChange = (value: string) => {
    setQuery({ ...query, typeId: value });
  };
  const onSelectedQueryDescriptionChange: React.ChangeEventHandler<HTMLTextAreaElement> = (event) => {
    setQuery({ ...query, description: event.target.value });
  };

  const onSelectedQueryCategoryChange = (value: string) => {
    setQuery({ ...query, categoryId: value });
  };

    const onSelectedQueryGroupCodeChange = (value: number) => {
        setQuery({ ...query, groupCodeId: value });
    };

    const onSelectedQueryEntityChange = (value: number) => {
        setQuery({ ...query, entityId: value });
    };

    const onSelectedQueryFieldChange = (value: number) => {
        setQuery({ ...query, fieldId: value });
    };
  
  const onSelectedQueryLabelChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    setQuery({ ...query, label: event.target.value });
  };

  const onSelectedQueryChange: React.ChangeEventHandler<HTMLTextAreaElement> = (event) => {
    setQuery({ ...query, query: event.target.value });
  };

  const handleOpenPopConfirm = (newOpen: boolean) => {
    setPopConfirmOpen(newOpen);
  }

    
  
  const handleSaveQuery = () => {
  
    const model = {
      categoryId: query.categoryId,
      description: query.description,
      entityId: query.entityId,
      fieldId: query.fieldId,
      groupCodeId: query.groupCodeId,
      id: query.id,
      isActive: query.isActive ?? true,
      isNeverCached: true,
      isSystemQuery: true,
      label: query.label,
      query: query.query,
      typeId: queryTypes.find((x:any) => x.value.toLowerCase().includes("flat"))?.index
    }
    if (model.id === -1) {
      ApplicationService.createCustomQuery(model)
        .then((response) => {
          //resetForm();
          //ApplicationService.getCustomQueries().then((response: any) => {
          //  setQueries(response.data);
          //});
          NotificationsUtil.openNotificationDialog({
            description: t(
              "fffff",
              {
                lngs: i18n.languages,
                defaultValue: "Query has been successfully created.",
              }
            )!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
          navigate(ROUTES.report.customQueries.route);
        })
        .catch((error) => {
          NotificationsUtil.openNotificationDialog({
            description: error.response.data,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        });
    } else {
      ApplicationService.updateCustomQuery({
        ...model
      })
        .then((response) => {
          resetForm();
          ApplicationService.getCustomQueries().then((response: any) => {
            setQueries(response.data);
          });
          NotificationsUtil.openNotificationDialog({
            description: t(
              "fffff",
              {
                lngs: i18n.languages,
                defaultValue: "Query has been successfully updated.",
              }
            )!,
            type: NOTIFICATION_TYPES.SUCCESS,
            logError: false,
          });
        })
        .catch((error) => {
          NotificationsUtil.openNotificationDialog({
            description: error.response.data,
            type: NOTIFICATION_TYPES.ERROR,
            logError: true,
          });
        });
    }
    }

    const handleRunQuery = async () => {
        try {
            setIsTableLoading(true);
            setErrorMessage(null); 
            const model = {
                id: query.id,
                entityId: query.entityId,
                fieldId: query.fieldId,
                groupCode: query.groupCode,
                isCreateTable: false,
            };

            const response = await ApplicationService.runCustomQuery(model);
            setTableViewData(response.data);
            const customQueriesResponse = await ApplicationService.getCustomQueries();
            setQueries(customQueriesResponse.data);
        } catch (error) {
            setErrorMessage(error.response.data);
            NotificationsUtil.openNotificationDialog({
                description: error.response.data,
                type: NOTIFICATION_TYPES.ERROR,
                logError: true,
            });
        } finally {
            setIsTableLoading(false);
        }
    };

    const handleRunWithoutStoring = () => {
        setIsTableLoading(true);
        const model = {
            id: query.id,
            entityId: query.entityId,
            fieldId: query.fieldId,
            groupCode: query.groupCode,
            isCreateTable: true,
        };
        ApplicationService.runCustomQuery(model)
            .then((response) => {
                setTableViewData(response.data);
                return ApplicationService.getCustomQueries();
            })
            .then((customQueriesResponse) => {
                setQueries(customQueriesResponse.data);
            })
            .catch((error) => {
                NotificationsUtil.openNotificationDialog({
                    description: error.response.data,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
            })
            .finally(() => {
                setIsTableLoading(false);
            });
    };
    
    const handleDeleteClick = () => {
        ApplicationService.deleteCustomQuery(id)
            .then((response: any) => {
                ApplicationService.getCustomQueries().then((response: any) => {
                    setQueries(response.data);
                });
                NotificationsUtil.openNotificationDialog({
                    description: t(
                        "Page.Operation.CustomQueries.Notifications.CustomQuery.DeleteSuccessDescription",
                        {
                            lngs: i18n.languages,
                            defaultValue: "Custom Query deleted successfully.",
                        }
                    )!,
                    type: NOTIFICATION_TYPES.SUCCESS,
                    logError: false,
                });
                navigate(ROUTES.report.customQueries.route);
            })
            .catch((error: any) => {
                NotificationsUtil.openNotificationDialog({
                    description: error.response.data,
                    type: NOTIFICATION_TYPES.ERROR,
                    logError: true,
                });
            });
    };

    const scroll = { y: "calc(100vh - 480px)" };
    
    const dropdownMenu = (

        <Menu>
            <Menu.Item key="1">
                    <Button
                        type="ghost"
                        size="small"
                        style={{ padding: "0px 2px", border: "none" }}
                        onClick={handleRunWithoutStoring}
                    >
                        {t("General.Labels.RunWithoutStoring", {
                            lngs: i18n.languages,
                            defaultValue: "Run without creating table",
                        })}
                    </Button>
            </Menu.Item>
        </Menu>
    );
  
  return (
    <div>
      <PageHead
        title={t("Page.Report.CustomQueries.Headers.CustomQueries", {
          lngs: i18n.languages,
          defaultValue: "Custom Queries",
        })}
        icon={<DiffOutlined />}
        routes={routes}
        groupCodes={groupCodes}
        entities={entities}
        operations={operations}
        selectedGroupCode={selectedGroupCode}
        selectedEntity={selectedEntity}
        selectedOperation={selectedOperation}
        setSelectedGroupCode={setSelectedGroupCode}
        setSelectedEntity={setSelectedEntity}
        setSelectedOperation={setSelectedOperation}
        setSelectGroupCodeDisabled={true}
        setSelectEntityDisabled={true}
        setSelectOperationDisabled={true}
        mainAction={[]}
        otherActions={[]}
        setActionsDisabled={false}
     />
        <div className="body-container">
            <div className="body-left">
                <div style={{display: "flex", flexDirection: "column"}}>
                    <div className="left-header" style={{}}>
                        <p>
                            {query.id != -1 ? (
                                <>
                                    Edit Query <span style={{color: "grey"}}>{query.id}</span>
                                </>
                            ) : (
                                "New Query"
                            )}
                        </p>
                        <Space>
                            <Popconfirm
                                style={{width: "400px"}}
                                placement="topRight"
                                title={
                                    <div
                                        style={{
                                            width: "400px",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        {t(
                                            "Page.Operation.ValidationRules.Tabs.ValidationMapping.Labels.ConfirmClose",
                                            {
                                                lngs: i18n.languages,
                                                defaultValue:
                                                    "Are you really sure that you want to close this drawer? All changes made will be lost.",
                                            }
                                        )}
                                    </div>
                                }
                                icon={<QuestionCircleOutlined style={{color: "red"}}/>}
                                visible={popConfirmOpen}
                                onVisibleChange={handleOpenPopConfirm}
                                onConfirm={() => handleDeleteClick()}
                                // onCancel={() => cancel}
                                okText={t("General.Actions.Yes", {
                                    lngs: i18n.languages,
                                    defaultValue: "Yes",
                                })}
                                cancelText={t("General.Actions.No", {
                                    lngs: i18n.languages,
                                    defaultValue: "No",
                                })}
                            >
                                <Button
                                    size="small"
                                    style={{color: '#a8071a', borderColor: '#a8071a'}}
                                >
                                    {t("General.Labels.Delete", {
                                        lngs: i18n.languages,
                                        defaultValue: "Delete",
                                    })}
                                </Button>
                            </Popconfirm>
                            <Button
                                type="ghost"
                                size="small"
                                // overlay={menu}
                                loading={downloadLoading}
                                style={{color: "#1E1E85"}}
                                className="button-blue"
                                onClick={handleSaveQuery}
                            >
                                {t("General.Labels.Save", {
                                    lngs: i18n.languages,
                                    defaultValue: "Save",
                                })}
                            </Button>
                        </Space>
                    </div>
                    <div className="left-form query-form" style={{display: "flex", paddingRight: 5}}>
                        <Form layout="vertical" size="small" style={{
                            width: "100%",
                            overflow: "auto",
                            // maxHeight: "calc(100vh - 410px)",
                            paddingRight: 20
                        }}>
                            <Form.Item
                                label={t("Page.Report.CustomQueries.Labels.Header.QueryLabel", {
                                    lngs: i18n.languages,
                                    defaultValue: "Label:",
                                })}
                            >
                                <Input
                                    placeholder="Enter Label"
                                    value={query.label}
                                    onChange={onSelectedQueryLabelChange}
                                />
                            </Form.Item>
                            <Form.Item
                                label={t("Page.Report.CustomQueries.Labels.Header.QueryDescription", {
                                    lngs: i18n.languages,
                                    defaultValue: "Description:",
                                })}>
                                <Input.TextArea
                                    placeholder="Enter description"
                                    value={query.description}
                                    onChange={onSelectedQueryDescriptionChange}/>
                            </Form.Item>

                            <div className="flex-container">
                                <Form.Item
                                    label={t("Page.Report.CustomQueries.Labels.Select.Category", {
                                        lngs: i18n.languages,
                                        defaultValue: "Category:",
                                    })}
                                >
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })}
                                        options={queryCategories.map((x: any) => ({
                                            label: x.value,
                                            value: x.index,
                                        }))}
                                        value={query.categoryId}
                                        onChange={onSelectedQueryCategoryChange}
                                        filterSort={(optionA, optionB) =>
                                            (optionA!.label as unknown as string)
                                                .toLowerCase()
                                                .localeCompare(
                                                    (optionB!.label as unknown as string).toLowerCase()
                                                )
                                        }
                                        filterOption={(inputValue: any, option: any) =>
                                            option!.label
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                    />
                                </Form.Item>
                            </div>
                            <Form.Item
                                label={t("Page.Report.CustomQueries.Labels.Input.Query", {
                                    lngs: i18n.languages,
                                    defaultValue: "Query:",
                                })}
                                tooltip={t("Page.Report.CustomQueries.Tooltips.Input.Query", {
                                    lngs: i18n.languages,
                                    defaultValue: "",
                                })}
                            >
                                <Input.TextArea
                                    placeholder="Enter Query"
                                    value={query.query}
                                    onChange={onSelectedQueryChange}
                                    rows={8}
                                    style={{scrollbarWidth:'thin'}}
                                />

                            </Form.Item>
                            <div className="flex-container">
                                <Form.Item
                                    label={t("Page.Report.CustomQueries.Labels.Select.GroupCode", {
                                        lngs: i18n.languages,
                                        defaultValue: "Group code:",
                                    })}
                                >
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })}
                                        options={groupCodes.map((x: any) => ({
                                            label: x.code,
                                            value: x.id,
                                        }))}
                                        value={query.groupCodeId}
                                        onChange={onSelectedQueryGroupCodeChange}
                                        filterSort={(optionA, optionB) =>
                                            (optionA!.label as unknown as string)
                                                .toLowerCase()
                                                .localeCompare(
                                                    (optionB!.label as unknown as string).toLowerCase()
                                                )
                                        }
                                        filterOption={(inputValue: any, option: any) =>
                                            option!.label
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t("Page.Report.CustomQueries.Labels.Select.Entity", {
                                        lngs: i18n.languages,
                                        defaultValue: "Entity:",
                                    })}
                                >
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })}
                                        options={entities.map((x: any) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        value={query.entityId}
                                        onChange={onSelectedQueryEntityChange}
                                        filterSort={(optionA, optionB) =>
                                            (optionA!.label as unknown as string)
                                                .toLowerCase()
                                                .localeCompare(
                                                    (optionB!.label as unknown as string).toLowerCase()
                                                )
                                        }
                                        filterOption={(inputValue: any, option: any) =>
                                            option!.label
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        style={{display: "block"}}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={t("Page.Report.CustomQueries.Labels.Select.Field", {
                                        lngs: i18n.languages,
                                        defaultValue: "Field:",
                                    })}
                                >
                                    <Select
                                        allowClear
                                        showSearch
                                        placeholder={t("General.Placeholders.SelectOption", {
                                            lngs: i18n.languages,
                                            defaultValue: "Select option",
                                        })}
                                        options={fields.map((x: any) => ({
                                            label: x.name,
                                            value: x.id,
                                        }))}
                                        value={query.fieldId}
                                        onChange={onSelectedQueryFieldChange}
                                        disabled={fields.length == 0}
                                        filterSort={(optionA, optionB) =>
                                            (optionA!.label as unknown as string)
                                                .toLowerCase()
                                                .localeCompare(
                                                    (optionB!.label as unknown as string).toLowerCase()
                                                )
                                        }
                                        filterOption={(inputValue: any, option: any) =>
                                            option!.label
                                                .toUpperCase()
                                                .indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                    />
                                </Form.Item>
                            </div>

                        </Form>
                    </div>

                    <div className="metadata-box">
                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <span style={{color: "rgba(0, 0, 0, 0.45)"}}>
                                    {t("Page.Report.CustomQueries.Labels.Input.CreatedBy", {
                                        lngs: i18n.languages,
                                        defaultValue: "Created By",
                                    })}
                                </span>
                                    }
                                    style={{marginBottom: "0px"}}
                                >
                                    <Typography.Text style={{color: "rgba(0, 0, 0, 0.45)", marginRight: "20px"}}>
                                        {query.createdBy ?? '/'}
                                    </Typography.Text>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <span style={{color: "rgba(0, 0, 0, 0.45)"}}>
                                    {t("Page.Report.CustomQueries.Labels.Input.LastEditedBy", {
                                        lngs: i18n.languages,
                                        defaultValue: "Last Edited By",
                                    })}
                                </span>
                                    }
                                    style={{marginBottom: "0px"}}
                                >
                                    <Typography.Text style={{color: "rgba(0, 0, 0, 0.45)"}}>
                                        {query.updatedBy ?? '/'}
                                    </Typography.Text>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <span style={{color: "rgba(0, 0, 0, 0.45)"}}>
                                    {t("Page.Report.CustomQueries.Labels.Input.LastRunDate", {
                                        lngs: i18n.languages,
                                        defaultValue: "Last Run Date",
                                    })}
                                </span>
                                    }
                                    style={{marginBottom: "0px"}}
                                >
                                    <Typography.Text style={{color: "rgba(0, 0, 0, 0.45)", marginRight: "20px"}}>
                                        {query.lastRunDate}
                                    </Typography.Text>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <span style={{color: "rgba(0, 0, 0, 0.45)"}}>
                                    {t("Page.Report.CustomQueries.Labels.Input.LastRunDateDuration", {
                                        lngs: i18n.languages,
                                        defaultValue: "Last Run Date Duration",
                                    })}
                                </span>
                                    }
                                    style={{marginBottom: "0px"}}
                                >
                                    <Typography.Text style={{color: "rgba(0, 0, 0, 0.45)", marginRight: "20px"}}>
                                        {query.lastRunDuration && query.lastRunDuration.split(' ')[1]}
                                    </Typography.Text>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <Form.Item
                                    label={
                                        <span style={{color: "rgba(0, 0, 0, 0.45)"}}>
                                    {t("Page.Report.CustomQueries.Labels.Input.Status", {
                                        lngs: i18n.languages,
                                        defaultValue: "Status",
                                    })}
                                </span>
                                    }
                                    style={{marginBottom: "0px"}}
                                >
                                    <Typography.Text style={{color: "rgba(0, 0, 0, 0.45)"}}>
                                        {query.status}
                                    </Typography.Text>
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>

            <div className="body-right">
                <div className="right-header">
                    <p>Results</p>
                    <div className={"action-buttons"} style={{gap: 0}}>
                        <Button
                            type="ghost"
                            size="small"
                            style={{padding: "0px 2px"}}
                            onClick={handleRunQuery}
                        >
                            {t("General.Labels.Run", {
                                lngs: i18n.languages,
                                defaultValue: "Run",
                            })}
                        </Button>
                        <Dropdown overlay={dropdownMenu} trigger={['click']}>
                            <Button
                                type="ghost"
                                size="small"
                                style={{padding: "0px 2px"}}
                                icon={<MoreOutlined/>}
                            />
                        </Dropdown>
                    </div>
                </div>
                <div className="right-content" >
                    <div>
                        {!tableViewData && !errorMessage && (
                            <Empty
                                description={
                                    <p>Please fill query on the left to get a result table.</p>
                                }
                            />
                        )}
                        {errorMessage && (
                            <div className="ant-table-placeholder">
                                <p style={{color: 'red'}}>{errorMessage}</p>
                            </div>
                        )}
                        {tableViewData && (
                            <Datatable
                                scroll={scroll}
                                tableColumns={tableColumns}
                                data={tableViewData}
                                setData={setTableViewData}
                                isTableLoading={isTableLoading}
                                otherActions={[]}
                                otherRowEnabled={false}
                                editRowEnabled={false}
                                copyRowEnabled={false}
                                deleteRowEnabled={false}
                                onEditFunc={undefined}
                                onCopyFunc={undefined}
                                onDeleteFunc={undefined}
                                onDoubleClickRow={undefined}
                                selectable={false}
                                multiSelect={false}
                                selectedRows={undefined}
                                setSelectedRows={undefined}
                                paginationVisible={true}
                                showActionsColumn={false}
                            />
                        )}
                    </div>
                </div>


            </div>
        </div>
    </div>
  );
};

export default QueryForm;

function renderTitle(arg0: string) {
    throw new Error("Function not implemented.");
}
